class BUTAnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.layout = this.getAttribute('data-section-layout');
      this.container = this.querySelector(".js-anmb-items");
      this.items = this.querySelectorAll(".js-anmb-item");

      // Store stable handler references (avoid repeated .bind resulting in leaks)
      this._onPrevClick = this.onPrevButtonClickHandler.bind(this);
      this._onNextClick = this.onNextButtonClickHandler.bind(this);
      this._onMouseOver = this.onMouseOverHandle.bind(this);
      this._onMouseOut = this.onMouseOutHandle.bind(this);
      this._onScroll = this.onScrollEventHandle.bind(this);
      this._onResize = this.checkTabletView.bind(this);
      this._observer = null;
    }
  
    init() {
      this.totalItems = this.items.length;
      this.previousButton = this.querySelector(".js-anmb-control-prev");
      this.nextButton = this.querySelector(".js-anmb-control-next");
      this.interval = null;
      this.currentItemIndex = 1;
      this.lastScrollTimeout = null;
      this.messages = this.container.children;
      this.isScrolling = false;
      this.bindEventHandlers();
      this.updateSort();
    }
  
    connectedCallback() {
      if(this.layout == 'running') return;
      if(this.layout == 'grid-desktop') {
        this.checkTabletView();
        window.addEventListener("resize", this._onResize);
      } else {
        this.init();
      }
    }
  
    checkTabletView() {
      const isTablet = window.matchMedia('(max-width: 458.9px)').matches;
      if (isTablet) {
  
        if (!this.isInitialized) {
          this.isInitialized = true;
          this.container.classList.add('ox-auto', 'disable-scrollbars', 'scrollable-stop-always', 'scrollable-x');
          this.init();
        }
      } else {
        if (this.isInitialized) {
          this.isInitialized = false;
          this.destroySlider();
        }
      }
    }
  
    destroySlider() {
      this.clearDismissInterval();
      this.container.classList.remove('ox-auto', 'disable-scrollbars', 'scrollable-stop-always', 'scrollable-x');
      this.container.removeAttribute("aria-live");
      if (this.container) {
        this.container.removeEventListener("mouseover", this._onMouseOver);
        this.container.removeEventListener("mouseout", this._onMouseOut);
        this.container.removeEventListener("scroll", this._onScroll, { passive: true });
      }
      if (this.previousButton) this.previousButton.removeEventListener("click", this._onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener("click", this._onNextClick);

      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }

      if (this.lastScrollTimeout) {
        clearTimeout(this.lastScrollTimeout);
        this.lastScrollTimeout = null;
      }
      
      this.isScrolling = false;
    }
  
    updateSort() {
      if (this.totalItems <= 1) return;
      this.isScrolling = true;
      let scrollLeftB = this.container.scrollLeft;
      let scrollLeft = Math.round(scrollLeftB);
      let offsetWidth = this.container.offsetWidth;
      let scrollWidth = this.container.scrollWidth;
  
      if (scrollLeft < offsetWidth) {
        this.container.prepend(this.messages[this.totalItems - 1]);
        this.container.scrollLeft = scrollLeft + offsetWidth;
      }
      if (Math.floor(scrollWidth - scrollLeftB) <= offsetWidth) {
        this.container.append(this.messages[0]);
        this.container.scrollLeft = scrollLeft - offsetWidth;
      }
      this.isScrolling = false;
    }
  
    onScrollEventHandle(e) {
      if (this.lastScrollTimeout) {
        clearTimeout(this.lastScrollTimeout);
      }
  
      this.lastScrollTimeout = setTimeout(
        function () {
          this.updateSort();
        }.bind(this),
        100
      );
    }
  
    bindEventHandlers() {
      if (!this.container) return;

      if (this.previousButton) this.previousButton.addEventListener("click", this._onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener("click", this._onNextClick);
      this.onObserverHandler();
      this.container.addEventListener("scroll", this._onScroll, { passive: true });
    }
  
    onPrevButtonClickHandler() {
      if (this.isScrolling) return;
      this.isScrolling = true;
      let index = this.currentItemIndex - 1;
      if (this.currentItemIndex == 1) {
        index = this.totalItems;
      }
    let matchingItem = this.querySelector(`div[data-item-index="${index}"]`);
  
      this.container.scrollTo({ left: matchingItem.offsetLeft, behavior: "smooth" });
    }
  
    onNextButtonClickHandler() {
      if (this.isScrolling) return;
      this.isScrolling = true;
      let index = this.currentItemIndex + 1;
      if (this.currentItemIndex == this.totalItems) {
        index = 1;
      }
      let matchingItem = this.querySelector(`div[data-item-index="${index}"]`);
  
      this.container.scrollTo({ left: matchingItem.offsetLeft, behavior: "smooth" });
    }
  
    onMouseOverHandle(evt) {
      this.clearDismissInterval();
    }
  
    onMouseOutHandle(evt) {
      this.setDismissInterval();
    }
  
    clearDismissInterval() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  
    setDismissInterval() {
      this.interval = setInterval(
        function () {
          this.onNextButtonClickHandler();
        }.bind(this),
        1000
      );
    }
  
    onObserverHandler() {
      if (!this.container) return;
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }

      let observe = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              let target = entry.target;
              window.requestAnimationFrame(() => {
                let activeItem = this.querySelector(".anmb-item--active");
                if (activeItem) {
                  activeItem.classList.remove("anmb-item--active");
                }
              });
              this.currentItemIndex = parseInt(target.dataset.itemIndex);
              window.requestAnimationFrame(() => target.classList.add("anmb-item--active"));
              let linkItem = target.querySelector(".js-anmb-link-items");
              linkItem && linkItem.removeAttribute("tabindex");
            }
          });
        },
        {
          root: this.container,
          rootMargin: "0px",
          threshold: 0.5,
        }
      );
      this.items.forEach(item => {
        observe.observe(item);
      });
      this._observer = observe;
    }
  }
  customElements.define("but-ann-bar", BUTAnnouncementBar);